const styles = () => ({
  listLabel: {
    fontWeight: 'bold'
  },
  listImage: {
    maxWidth: '50%',
    objectFit: 'contain'
  },
  listItem: {}
});

export default styles